import React from 'react'

function MainCard({children,className,...props}:CardPropsType) {
  return (
    <div className={`bg-white shadow-card rounded-[20px]  lg:px-[2.5rem] lg:py-[1.87rem] px-[20px] py-[20px] ${className}`} {...props}>{children}</div>
  )
}

export default MainCard
export type CardPropsType = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>